module.exports = __webpack_public_path__ + "img/RX1HS5x7400.e30dc584.jpg";